import React from 'react';
import { Segment, Header, Icon } from 'semantic-ui-react';

const segmentStyle = {
  width: '100%',
  paddingTop: 75,
  paddingBottom: 75,
  background: 'transparent',
  border: 'none',
  boxShadow: 'none',
};

export const EmptyState = () => (
  <Segment style={segmentStyle} padded textAlign="center">
    <Header as="h2" icon size="medium">
      <Icon name="warning circle" color="orange" />
        No pending invitations
      <Header.Subheader>
      Please try again later
      </Header.Subheader>
    </Header>
  </Segment>
);

export const LoadingState = () => (
  <Segment style={segmentStyle} padded textAlign="center">
    <Header as="h2" icon size="medium">
      <Icon
        name="refresh"
        loading
      />
      Loading invitations..
    </Header>
  </Segment>
);



/** WEBPACK FOOTER **
 ** ./src/components/pending-invitations-list/states.js
 **/